import { useEffect } from "react";
import { useBrand } from "../context/BrandContext";
import { applyAppUnreadBadge, clearAppUnreadBadge } from "../utils/appUnreadBadge";

export function useAppUnreadBadge(unreadCount) {
  const brand = useBrand();
  const count = Math.max(0, Number(unreadCount) || 0);

  useEffect(() => {
    const opts = {
      baseTitle: brand.title,
      faviconUrl: brand.assets.favicon,
    };

    if (count > 0) {
      applyAppUnreadBadge(count, opts);
    } else {
      clearAppUnreadBadge(opts);
    }

    return () => clearAppUnreadBadge(opts);
  }, [count, brand.title, brand.assets.favicon]);
}
